// https://vike.dev/meta

import type { PageContext } from "vike/types";
import { getPageMetadata } from "../../utils/languageMetadata.js";

export default function title(pageContext: PageContext) {
  // Get the current language from route params (server-side) or default to Spanish
  const currentLanguage = pageContext.routeParams?.language || "es";
  const pageMeta = getPageMetadata(currentLanguage, "sentences");
  
  return pageMeta.title;
}
